export enum PackageSize {
  N1 = 'N1',
  N2 = 'N2',
  N3 = 'N3',
  NOT_SPECIFIED = 'NOT_SPECIFIED',
}
